import { PrankDefinition, Intensity } from './types';

const TICK_MS = 15000;
const SATURATION_STEP = 0.5;
const MAX_SATURATION = 100;
const INTENSE_MULTIPLIER = 5;

const greyscalePrank: PrankDefinition = {
  namedCode: 'gray',
  hexCode: 'f4c1',
  create: (intensity) => {
    const speed = intensity === Intensity.INTENSE ? INTENSE_MULTIPLIER : 1;
    let saturation = 0;

    const interval = setInterval(() => {
      saturation = Math.min(MAX_SATURATION, saturation + SATURATION_STEP);
      document.documentElement.style.filter = `grayscale(${saturation}%)`;
    }, TICK_MS / speed);

    return () => {
      clearInterval(interval);
      document.documentElement.style.filter = '';
    };
  },
};

export default greyscalePrank;
